import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { FieldArray, Form, Formik, Field } from "formik";
import {
  Grid,
  Typography,
  RadioGroup,
  FormControlLabel,
  Paper,
  Radio,
  useTheme
} from "@material-ui/core";

import AddCircleIcon from "@material-ui/icons/AddCircle";
import RemoveIcon from "@material-ui/icons/Remove";

import { ROUTE_PATHS } from "../../../utils/PathsNames";
import CustomLink from "../../../components/Link";
import {
  getSingleBookRequest,
  getSingleBookResponse,
  getBookSectionsRequest,
  getBookSectionsResponse
} from "../../../store/Books/actions";
import Input from "../../../components/Input";
import Button from "../../../components/Button";
import {
  ADD_EDIT_TEST_SCHEMA,
  getInitialValuesAdd,
  getInitialValuesEdit
} from "./validation";
import { showHideLoader } from "../../../store/Loader/actions";
import {
  addTestsRequest,
  getSingleTestRequest,
  getSingleTestResponse,
  editTestRequest,
  checkForCanBeEditTestRequest,
  checkForCanBeEditTestResponse
} from "../../../store/Tests/actions";
import { getBooksRequest } from "../../../store/Books/actions";
import CustomSelect from "../../../components/Select";
import { formatOptions } from "../../../utils/Helpers";
// import Upload from "./testImageUploading";
import Upload from "../../../components/Upload";
import MaterialPreview from "../../../components/MaterialPreview";
import styles from "./PreTestPostTestForm.module.scss";
import { showHideSnackbar } from "../../../store/Snackbar/actions";
import { uploadToS3 } from "../../../utils/S3";
import TestAnswerForm from "./TestAnswerForm/TestAnswerForm";

const PreTestPostTestForm = () => {
  const dispatch = useDispatch();
  const { locale, messages } = useIntl();

  const formRef = useRef();
  const uploadQuestionRef = useRef();
  const uploadJustificationRef = useRef();

  const {
    preTestPostTest: {
      addTest,
      editTest,
      titleLabel,
      questionTitle,
      book,
      prePage,
      postPage,
      mandatory,
      optional,
      selectTestTypeLabel,
      upload,
      uploadImageLabel,
      explanation,
      questionPoints,
      testAnswered,
      addSection,
      noOption,
      notes,
      noteHint,
      sectionName,
      none
    },
    buttons: { submit }
  } = messages;

  let params = useParams();

  const theme = useTheme();
  const [mode, setMode] = useState("add");
  const [isDicom, setIsDicom] = useState(false);

  const [
    sectionsInBookOptionsSelect,
    setsectionsInBookOptionsSelect
  ] = useState(null);

  const books = useSelector((state) => state.books.list);

  const sectionsInBook = useSelector(
    (state) => state.books.sectionsInBookOptions
  );
  const [optionsToGetSection, setOptionsToGetSection] =
    useState(sectionsInBook);
  const singleTest = useSelector((state) => state.tests.singleTest);
  const CanBeEditTest = true;
  const singleBook = useSelector((state) => state.books.singleBook);
  useEffect(() => {
    if (params?.id)
      dispatch(
        getBookSectionsRequest({
          bookId: singleTest?.book_id,
          prePage: singleTest?.pre_page,
          postPage: singleTest?.post_page
        })
      );

    setOptionsToGetSection(sectionsInBook);
  }, [params, singleTest]);
  useEffect(async () => {
    setIsDicom(false);
    await dispatch(getBooksRequest({ lookup: true }));
  }, []);

  useEffect(async () => {
    if (sectionsInBookOptionsSelect)
      await dispatch(
        getBookSectionsRequest(sectionsInBookOptionsSelect)
      );
  }, [sectionsInBookOptionsSelect]);

  useEffect(async () => {
    if (params?.id)
      await dispatch(
        getBookSectionsRequest({
          bookId: singleTest?.book_id,
          from: singleTest?.pre_page,
          to: singleTest?.post_page,
          page: -1
        })
      );
  }, [singleTest]);

  useEffect(() => {
    setOptionsToGetSection(sectionsInBook);
  }, [sectionsInBook]);

  useEffect(() => {
    if (params?.id) {
      setMode("edit");
      dispatch(getSingleTestRequest(params.id));
      dispatch(checkForCanBeEditTestRequest({ id: params?.id }));
    }
  }, [params]);

  useEffect(() => {
    return () => {
      dispatch(getSingleBookResponse(null));
      dispatch(checkForCanBeEditTestResponse(true));
      dispatch(getSingleTestResponse({}));

      dispatch(getBookSectionsResponse({ list: [], meta: null }));
    };
  }, []);

  const updatedQuestions = async (values) => {
    return await Promise.all(
      values.test_questions_attributes.map(async (question) => {
        const updatedQuestion = { ...question };

        // Handle question image
        try {
          if (updatedQuestion.image_url?.file instanceof File) {
            const { link } = await uploadToS3(
              "private",
              updatedQuestion.image_url.file,
              updatedQuestion.image_url.file.name
            );
            updatedQuestion.image_url = link;
          }
        } catch (err) {
          console.error("Failed to upload question image", err);
          updatedQuestion.image_url = null; // or keep the file
        }

        // Handle justification image
        try {
          if (
            updatedQuestion.justification_image_url?.file instanceof
            File
          ) {
            const { link } = await uploadToS3(
              "private",
              updatedQuestion.justification_image_url.file,
              updatedQuestion.justification_image_url.file.name
            );
            updatedQuestion.justification_image_url = link;
          }
        } catch (err) {
          console.error("Failed to upload justification image", err);
          updatedQuestion.justification_image_url = null;
        }

        // Handle answers
        updatedQuestion.test_answer_choices_attributes =
          await Promise.all(
            question.test_answer_choices_attributes.map(
              async (answer) => {
                const updatedAnswer = { ...answer };

                try {
                  if (
                    updatedAnswer.currentTab !== "text" &&
                    updatedAnswer.image_url?.file instanceof File
                  ) {
                    const { link } = await uploadToS3(
                      "private",
                      updatedAnswer.image_url.file,
                      updatedAnswer.image_url.file.name
                    );
                    updatedAnswer.image_url = link;
                  }
                } catch (err) {
                  console.error("Failed to upload answer image", err);
                  updatedAnswer.image_url = null;
                }

                return updatedAnswer;
              }
            )
          );

        return updatedQuestion;
      })
    );
  };
  const handleSubmit = async (values) => {
    dispatch(showHideLoader(true));

    try {
      if (mode === "add") {
        values.test_questions_attributes = await updatedQuestions(
          values
        );
        dispatch(addTestsRequest(values));
      } else {
        values.test_questions_attributes = await updatedQuestions(
          values
        );
        dispatch(
          editTestRequest({
            data: values,
            id: singleTest.id
          })
        );
      }
    } catch (e) {
      console.error("Failed to prepare quiz data", e);
    }
  };

  const AddRemoveNewQuestion = (push) => {
    return (
      <>
        <div className="mx-2 mb-3">
          <AddCircleIcon
            className="cursor-pointer"
            onClick={() =>
              push({
                question: "",
                points: null,
                test_answer_choices_attributes: [
                  {
                    currentTab: "text",
                    answer: "",
                    image_url: "",
                    correct: false,
                    justification: ""
                  },
                  {
                    currentTab: "text",
                    answer: "",
                    image_url: "",
                    correct: false,
                    justification: ""
                  }
                ]
              })
            }
          />
        </div>
      </>
    );
  };

  const RemoveQuestion = (
    question,
    remove,
    questionIndex,
    replace
  ) => {
    return () => {
      if (!question.id) {
        remove(questionIndex);
        return;
      }
      replace(questionIndex, {
        ...question,
        _destroy: true
      });
    };
  };

  async function handleUploadSingleImage(e, qIndex, type) {
    let file = e?.target?.files[0];
    if (file) {
      if (file?.type?.includes("image")) {
        let url = URL.createObjectURL(file);
        let objFile = { file, url };

        if (type == "question") {
          formRef.current.setFieldValue(
            `test_questions_attributes[${qIndex}].image_url`,
            objFile
          );
          if (uploadQuestionRef.current)
            uploadQuestionRef.current.value = null;
        } else if (type == "justification") {
          formRef.current.setFieldValue(
            `test_questions_attributes[${qIndex}].justification_image_url`,
            objFile
          );
          if (uploadJustificationRef.current)
            uploadJustificationRef.current.value = null;
        }
        // Clear input value
        e.target.value = null;
      } else {
        dispatch(
          showHideSnackbar({
            type: "error",
            isOpen: true,
            message: "Please select image"
          })
        );
      }
    }
  }
  return (
    <>
      <div className="mb-4">
        <Typography variant="h4" component="h1">
          {mode === "edit" ||
          JSON.parse(sessionStorage.getItem("bookSelected"))?.id
            ? editTest
            : addTest}
        </Typography>
      </div>
      <Formik
        innerRef={formRef}
        initialValues={
          sessionStorage.getItem("bookSelected")
            ? JSON.parse(sessionStorage.getItem("bookSelected"))
            : mode === "add"
            ? getInitialValuesAdd()
            : getInitialValuesEdit(singleTest)
        }
        onSubmit={handleSubmit}
        validationSchema={ADD_EDIT_TEST_SCHEMA(locale)}
        enableReinitialize
      >
        {({ setFieldValue, values }) => {
          {
            /* console.log("values", values);
          console.log("errors", errors); */
          }
          return (
            <Form>
              <fieldset
                disabled={!CanBeEditTest}
                className={
                  !CanBeEditTest ? styles.disableFormEdit : null
                }
              >
                <Grid container spacing={5}>
                  <Grid item className="pb-0">
                    <Input
                      name="title"
                      label={titleLabel}
                      isRequired={true}
                      type="text"
                    />
                    <div className="mb-4">
                      <label>{selectTestTypeLabel}</label>
                      <RadioGroup
                        name="is_mandatory"
                        className="flex-nowrap flex-row"
                        value={`${values.is_mandatory}`}
                        onChange={(e) => {
                          setFieldValue(
                            "is_mandatory",
                            e.target.value
                          );
                        }}
                      >
                        <FormControlLabel
                          value="true"
                          control={<Radio />}
                          label={mandatory}
                        />
                        <FormControlLabel
                          value="false"
                          control={<Radio />}
                          label={optional}
                        />
                      </RadioGroup>
                    </div>
                    <div className={styles.selectTitle}>
                      {mode === "edit" && (
                        <label className={styles.label}>
                          {book} <span>*</span>{" "}
                        </label>
                      )}
                      <CustomSelect
                        options={books.map((book) =>
                          formatOptions(book, "id", "title")
                        )}
                        placeholder={book}
                        name="book_id"
                        bgColor={theme.palette.primary.light}
                        isRequired={true}
                        isMenuRelative={true}
                        isSearchable={true}
                        onChange={(e) => {
                          setFieldValue("book_id", e.id);
                          setOptionsToGetSection([]);

                          values.test_questions_attributes.map(
                            (question, questionIndex) => {
                              setFieldValue(
                                `test_questions_attributes[${questionIndex}].section_id`,
                                null
                              );
                            }
                          );
                        }}
                        handleSelectChange={() => {
                          if (values.book_id)
                            dispatch(
                              getSingleBookRequest(values.book_id)
                            );
                        }}
                        containerClass="mb-4"
                      />
                    </div>
                    <div className="d-flex mb-4">
                      <div className={styles.mr2}>
                        <Input
                          name="pre_page"
                          label={prePage}
                          isRequired={true}
                          type="number"
                          isNumber={true}
                          onInput={() => {
                            setOptionsToGetSection([]);

                            values.test_questions_attributes.map(
                              (question, questionIndex) => {
                                setFieldValue(
                                  `test_questions_attributes[${questionIndex}].section_id`,
                                  null
                                );
                              }
                            );
                          }}
                          onChange={(e) => {
                            setFieldValue(
                              "pre_page",
                              e.target?.value
                            );
                          }}
                        />
                      </div>

                      <div>
                        <Input
                          name="post_page"
                          label={postPage}
                          isRequired={true}
                          isNumber={true}
                          type="number"
                          max={singleBook?.number_of_pages}
                          onInput={() => {
                            setOptionsToGetSection([]);

                            values.test_questions_attributes.map(
                              (question, questionIndex) => {
                                setFieldValue(
                                  `test_questions_attributes[${questionIndex}].section_id`,
                                  null
                                );
                              }
                            );
                          }}
                          onChange={(e) => {
                            setFieldValue(
                              "post_page",
                              e.target?.value
                            );
                          }}
                        />
                      </div>
                    </div>
                    <div>
                      <p>{noteHint}</p>
                      <Input
                        inputShape="textarea"
                        showCounter={true}
                        charLimit={800}
                        name="note"
                        label={notes}
                        isRequired={false}
                        type="text"
                      />
                    </div>

                    <div className="mb-4">
                      <FieldArray name="test_questions_attributes">
                        {({ push, replace, remove }) => {
                          return !values?.test_questions_attributes
                            ?.length
                            ? null
                            : values?.test_questions_attributes?.map(
                                (question, questionIndex) => {
                                  return (
                                    !question._destroy && (
                                      <div className="d-flex">
                                        <Paper
                                          style={{ padding: "2rem" }}
                                          className="row align-items-center justify-content-center flex-fill mb-4"
                                        >
                                          <div className="d-flex align-items-center justify-content-between">
                                            <div
                                              style={{
                                                width: "100%"
                                              }}
                                            >
                                              <Input
                                                name={`test_questions_attributes[${questionIndex}].question`}
                                                label={questionTitle}
                                                isRequired={true}
                                              />
                                            </div>

                                            <a
                                              data-bs-toggle="collapse"
                                              href={`#collapseExample${questionIndex}`}
                                              role="button"
                                              aria-expanded="false"
                                              aria-controls="collapseExample"
                                              style={{
                                                width: "100px",
                                                marginLeft: "10px"
                                              }}
                                              className="mb-4"
                                            >
                                              {uploadImageLabel}
                                            </a>
                                          </div>

                                          <div
                                            className={
                                              !values
                                                ?.test_questions_attributes[
                                                questionIndex
                                              ].image_url
                                                ? " collapse p-2 mb-2 "
                                                : "collapse show p-2 mb-2"
                                            }
                                            id={`collapseExample${questionIndex}`}
                                          >
                                            <div className="d-flex align-items-center justify-content-between">
                                              <Grid
                                                item
                                                className="pb-0"
                                                xs={6}
                                              >
                                                <div className="text-center">
                                                  <div className="mb-3 d-flex flex-column align-items-center">
                                                    <MaterialPreview
                                                      type={1}
                                                      isPublic={false}
                                                      src={
                                                        question
                                                          .image_url
                                                          ?.url ||
                                                        question.image_url
                                                      }
                                                      hasClear={true}
                                                      onClear={() => {
                                                        setFieldValue(
                                                          `test_questions_attributes[${questionIndex}].image_url`,
                                                          ""
                                                        );
                                                      }}
                                                    />
                                                  </div>
                                                  <Upload
                                                    label={upload}
                                                    ref={
                                                      uploadQuestionRef
                                                    }
                                                    onChange={(e) =>
                                                      handleUploadSingleImage(
                                                        e,
                                                        questionIndex,
                                                        "question"
                                                      )
                                                    }
                                                    name={`test_questions_attributes[${questionIndex}].image_url`}
                                                    accept="image/*"
                                                    isImage={true}
                                                    setFieldValue={
                                                      setFieldValue
                                                    }
                                                    isRequired={true}
                                                    isMultiple={false}
                                                  />
                                                </div>
                                              </Grid>
                                            </div>
                                          </div>
                                          <Input
                                            style={{ width: "100%" }}
                                            name={`test_questions_attributes[${questionIndex}].points`}
                                            label={questionPoints}
                                            isRequired={true}
                                            type="number"
                                            isNumber={true}
                                            step="0.1"
                                          />

                                          <div
                                            className={
                                              styles.relativeContainer
                                            }
                                          >
                                            <div
                                              className={
                                                styles.selectTitle
                                              }
                                            >
                                              {mode === "edit" && (
                                                <label
                                                  className={
                                                    styles.label
                                                  }
                                                >
                                                  {sectionName}{" "}
                                                </label>
                                              )}
                                              <Field
                                                isSearchable={true}
                                                disabled={
                                                  !values.post_page ||
                                                  !values.pre_page ||
                                                  !values.book_id
                                                }
                                                component="select"
                                                name={`test_questions_attributes[${questionIndex}].section_id`}
                                                className={`form-control ${styles.selectField}`}
                                                onClick={() =>
                                                  setsectionsInBookOptionsSelect(
                                                    {
                                                      prePage:
                                                        values.pre_page,
                                                      postPage:
                                                        values.post_page,
                                                      bookId:
                                                        values.book_id,
                                                      page: -1
                                                    }
                                                  )
                                                }
                                              >
                                                <option
                                                  value=""
                                                  selected
                                                  disabled
                                                  hidden
                                                >
                                                  {addSection}
                                                </option>

                                                <option
                                                  disabled
                                                ></option>

                                                {optionsToGetSection?.length >
                                                0 ? (
                                                  <>
                                                    {[
                                                      {
                                                        id: "",
                                                        value: "",
                                                        name: `${none}`
                                                      },
                                                      ...optionsToGetSection
                                                    ].map(
                                                      (section) => {
                                                        return (
                                                          <>
                                                            <option
                                                              value={
                                                                section.id
                                                              }
                                                            >
                                                              {
                                                                section?.name
                                                              }
                                                            </option>
                                                            <option
                                                              disabled
                                                            ></option>
                                                          </>
                                                        );
                                                      }
                                                    )}
                                                  </>
                                                ) : (
                                                  <>
                                                    <option
                                                      value=""
                                                      selected
                                                      disabled
                                                      hidden
                                                    >
                                                      {addSection}
                                                    </option>
                                                    <option
                                                      key={0}
                                                      disabled
                                                    >
                                                      {noOption}
                                                    </option>
                                                  </>
                                                )}
                                              </Field>
                                            </div>
                                            {values?.book_id ? (
                                              <div
                                                onClick={() => {
                                                  if (
                                                    mode === "edit"
                                                  ) {
                                                    sessionStorage.setItem(
                                                      "bookSelected",
                                                      JSON.stringify({
                                                        id: singleTest.id,
                                                        ...values
                                                      })
                                                    );
                                                    return;
                                                  } else {
                                                    sessionStorage.setItem(
                                                      "bookSelected",
                                                      JSON.stringify(
                                                        values
                                                      )
                                                    );
                                                  }
                                                }}
                                              >
                                                <CustomLink
                                                  slug={`${ROUTE_PATHS.bookDetails}/${values?.book_id}?test=true`}
                                                  linkText={
                                                    addSection
                                                  }
                                                />
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                          <TestAnswerForm
                                            question={question}
                                            questionIndex={
                                              questionIndex
                                            }
                                            setFieldValue={
                                              setFieldValue
                                            }
                                            formRef={formRef}
                                            mode={mode}
                                            isDicom={isDicom}
                                          />
                                          <div className="my-2">
                                            <Input
                                              name={`test_questions_attributes[${questionIndex}].justification`}
                                              label={explanation}
                                              isRequired={false}
                                            />
                                            <div className="mb-3 d-flex flex-column  align-items-end w-50 gap-3">
                                              <MaterialPreview
                                                type={1}
                                                isPublic={false}
                                                src={
                                                  question
                                                    ?.justification_image_url
                                                    ?.url ||
                                                  question?.justification_image_url
                                                }
                                                hasClear={true}
                                                onClear={() => {
                                                  setFieldValue(
                                                    `test_questions_attributes[${questionIndex}].justification_image_url`,
                                                    ""
                                                  );
                                                }}
                                              />
                                              <Upload
                                                ref={
                                                  uploadJustificationRef
                                                }
                                                onChange={(e) =>
                                                  handleUploadSingleImage(
                                                    e,
                                                    questionIndex,
                                                    "justification"
                                                  )
                                                }
                                                label={upload}
                                                name={`test_questions_attributes[${questionIndex}].justification_image_url`}
                                                accept="image/*"
                                                isImage={true}
                                                setFieldValue={
                                                  setFieldValue
                                                }
                                                isRequired={false}
                                                isMultiple={
                                                  isDicom
                                                    ? true
                                                    : false
                                                }
                                              />
                                            </div>
                                          </div>
                                        </Paper>
                                        <div
                                          className="d-flex flex-row mb-4  align-items-center mx-5"
                                          key={JSON.stringify(
                                            questionIndex
                                          )}
                                        >
                                          {values
                                            .test_questions_attributes
                                            .length > 1 &&
                                            !question?._destroy &&
                                            values.test_questions_attributes.filter(
                                              (x) => !x._destroy
                                            ).length !== 1 && (
                                              <div className="mx-2 mb-3">
                                                <RemoveIcon
                                                  onClick={RemoveQuestion(
                                                    question,
                                                    remove,
                                                    questionIndex,
                                                    replace
                                                  )}
                                                  className="cursor-pointer"
                                                  disabled={
                                                    values.test_questions_attributes.filter(
                                                      (x) =>
                                                        !x._destroy
                                                    ).length === 1
                                                  }
                                                />
                                              </div>
                                            )}
                                          {AddRemoveNewQuestion(push)}
                                        </div>
                                      </div>
                                    )
                                  );
                                }
                              );
                        }}
                      </FieldArray>
                    </div>
                  </Grid>
                  <Grid item xs={6} className="pb-0"></Grid>
                </Grid>
              </fieldset>
              <div className="d-block mt-3 ">
                <Button
                  text={submit}
                  className="primary-lg"
                  type="submit"
                  data-toggle="tooltip"
                  data-placement="top"
                  disabled={!CanBeEditTest}
                  title={!CanBeEditTest ? testAnswered : ""}
                />
              </div>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default PreTestPostTestForm;
